import GuageChart from './GuageChart';

export default GuageChart;
